import { render, staticRenderFns } from "./Rfis.vue?vue&type=template&id=ed82aff0&scoped=true"
import script from "./Rfis.vue?vue&type=script&lang=js"
export * from "./Rfis.vue?vue&type=script&lang=js"
import style0 from "./Rfis.vue?vue&type=style&index=0&id=ed82aff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed82aff0",
  null
  
)

export default component.exports